module.exports = __webpack_public_path__ + "img/ycb.85187aff.jpg";